import { differenceInMinutes } from "date-fns";

/**
 * Returns true when `now` falls within the half-open window
 * [shiftStart - windowMinutesBefore, shiftStart + windowMinutesAfter).
 */
export function isWithinEtaUpdateWindow(params: {
  now: Date;
  shiftStart: Date;
  windowMinutesBefore: number;
  windowMinutesAfter: number;
}): boolean {
  const { now, shiftStart, windowMinutesBefore, windowMinutesAfter } = params;
  const minutesFromShiftStart = differenceInMinutes(now, shiftStart);
  return (
    minutesFromShiftStart >= -windowMinutesBefore && minutesFromShiftStart < windowMinutesAfter
  );
}
